'use strict';
(()=>{
 const motion=window.EnchantedMotion;
 document.addEventListener('click',event=>{
  const open=event.target.closest('[data-open]');if(open)motion.open(document.getElementById(open.dataset.open),open);
  const close=event.target.closest('[data-close]');if(close)motion.close(close.closest('dialog'));
  const thumb=event.target.closest('[data-product-image]');if(thumb){const section=thumb.closest('[data-product]');motion.swapImage(section.querySelector('.main-product-image'),thumb.dataset.productImage,thumb.querySelector('img')?.alt);section.querySelectorAll('[data-product-image]').forEach(button=>{const chosen=button===thumb;button.classList.toggle('thumb-selected',chosen);button.setAttribute('aria-pressed',String(chosen))})}
 });
 document.addEventListener('change',event=>{
  if(event.target.matches('[data-language-select]'))event.target.form.requestSubmit();
  if(event.target.matches('[data-variant-select]')){
   const select=event.target,section=select.closest('[data-product]'),option=select.selectedOptions[0],submit=section.querySelector('[data-add-button]'),price=section.querySelector('[data-product-price]');
   price.textContent=option.dataset.price;motion.animate(price,[{opacity:.45},{opacity:1}],{duration:200});
   submit.disabled=option.dataset.available!=='true';submit.textContent=submit.disabled?submit.dataset.soldOut:submit.dataset.add;
   const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
   if(option.dataset.image)motion.swapImage(section.querySelector('.main-product-image'),option.dataset.image);
  }
 });
})();
